import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { SearchFormService } from "../core/services/search-form.service";
import { Employee } from "../core/models/employee.model";
import { Pagination } from "../core/models/pagination.model";
import { Verification } from "../core/models/verification.model";
import { VerificationService } from "../core/services/verification.service";
import { environment } from "../../environments/environment";
import { JwtService } from "../core/services/jwt.service";
import { EmployeeService } from "../core/services/employee.service";
import { CommonService } from "../core/services/common.service";

@Component({
    selector: 'app-search-result',
    templateUrl: './search-result.component.html',
    styleUrls: ['./search-result.component.css']
})
export class SearchResultComponent implements OnInit {

    query: string;
    employees: Employee[] = [];
    pagination: Pagination = new Pagination;
    verifications: Verification[] = [];
    clientUrl: string;
    crmUrl: string;
    token = null;
    filterParams: URLSearchParams = new URLSearchParams();

    constructor(
        private verificationService: VerificationService,
        private searchFormService: SearchFormService,
        private route: ActivatedRoute,
        private jwtService: JwtService,
        private employeeService: EmployeeService,
        private commonService: CommonService
    ) {
        this.query = '';
        this.clientUrl = environment.client_url;
        this.crmUrl = environment.crm_url;
        this.token = this.jwtService.getToken();
    }


    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            Object.keys(params).forEach(key => {
                if (params[key] !== '') {
                    this.query = params[key];
                }
            });
            this.verificationService.getAllVerifications().then(verifications => this.verifications = verifications);
            this.getEmployees(this.query);
        });
    }

    getEmployees(query) {
        this.searchFormService.searchEmployee(query).subscribe(
            pagination => {
                this.pagination = pagination
            }
        );
    }

    downloadDocuments(employee, i) {

        this.employeeService.getDocuments(employee.id, this.filterParams).subscribe(response => {
            if (response.success) {
                window.location.href = this.clientUrl + 'employees/' + employee.id + '/download-documents?download=yes&token=' + this.token;
            }
            else {
                this.commonService.notifications.error('No Documents To Download');
            }

        });
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/search-result/search-result.component.ts